import api from '@/lib/api'

const state = () => ({
  all: [],
  offered: [],
})

const getters = {
  all: state => state.all,
  offered: state => state.offered,

  byCategory: state => {
    let result = {}

    state.all.forEach( service => {
      service.categories.forEach( category => {
        if (category.name in result) {
          result[category.name].push(service)
        } else {
          result[category.name] = [service]
        }
      })
    })

    return result
  },

  categories: (_state, getters) => Object.keys(getters.byCategory).sort(),
}

const actions = { 
  async loadAll({ commit }) {
    const result = await api.get('/services')
    if (result.ok) {
      commit('SET_ALL', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },

  async loadOffered({ commit }) {
    const result = await api.get('/services/offered')
    if (result.ok) {
      commit('SET_OFFERED', await result.json())
      return { ok: true }
    }
  
    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_ALL: (state, services) => state.all = services,
  SET_OFFERED: (state, services) => state.offered = services,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}